import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ExperienceState {
  experiences: any[];
  experience: any;
  isLoading: boolean;
}

const EXPERIENCE_INITIAL: ExperienceState = {
  experiences: [],
  experience: {},
  isLoading: false,
};

const experienceSlice = createSlice({
  name: "experience",
  initialState: {
    ...EXPERIENCE_INITIAL,
  },
  reducers: {
    EXPERIENCE_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Number | Object;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { EXPERIENCE_UPDATE } = experienceSlice.actions;

export { experienceSlice, EXPERIENCE_INITIAL, EXPERIENCE_UPDATE };
